import { ApolloProvider } from '@apollo/client';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/JWTContext';
import { client } from './graphql';
import { DEFAULT_LOCALE, activateLocale } from './utils/i18n/activateLocale';

// En la rama MUI esto lo hace useI18n, que esta rama no carga.
activateLocale(DEFAULT_LOCALE);

// Rama de las rutas de src/fsd/: sin MUI, Redux ni los componentes globales del producto.
// Vive aparte de AppContexts.tsx porque importar ese archivo descarga la rama MUI entera.
// El scroll lo maneja el `ScrollRestoration` de AppLayout: un reset por navegación lo pisaría.
export const FsdContext = () => (
  <ApolloProvider client={client}>
    <I18nProvider i18n={i18n}>
      <AuthProvider>
        <Outlet />
      </AuthProvider>
    </I18nProvider>
  </ApolloProvider>
);
